const variants = {
  primary: "bg-[#354BCA] text-white hover:scale-[1.02]",
  secondary: "bg-[#1F1F1F] text-white hover:scale-[1.02]",
};

export default function SmotriButton({
  as: Component = "button",
  children,
  className = "",
  type = "button",
  variant = "primary",
  ...props
}) {
  const typeProps = Component === "button" ? { type } : {};

  return (
    <Component
      className={`jost-m h-14 rounded-2xl px-4 text-base font-medium shadow-[0_4px_20px_rgba(0,0,0,0.3)] transition-transform ${variants[variant]} ${className}`}
      {...typeProps}
      {...props}
    >
      {children}
    </Component>
  );
}
